"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 24px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block;\n    white-space: nowrap;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 20px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PhoneSupportWrapper = _styledComponents.default.div.withConfig({
  displayName: "PhoneSupport__PhoneSupportWrapper",
  componentId: "sc-6geeux-0"
})(["", ""], _responsiveBreakpoints.default.tablet(_templateObject()));

var PhoneSupportContainer = _styledComponents.default.div.withConfig({
  displayName: "PhoneSupport__PhoneSupportContainer",
  componentId: "sc-6geeux-1"
})(["border:", ";border-radius:200px;margin:0 auto;text-align:center;padding:15px 44px 0;"], function (_ref) {
  var border = _ref.border;
  return border ? "1px " + _colors.BATTLESHIP + " solid" : 'none';
});

var PhoneNumberContainer = _styledComponents.default.div.withConfig({
  displayName: "PhoneSupport__PhoneNumberContainer",
  componentId: "sc-6geeux-2"
})(["display:inline-flex;align-items:flex-start;", ""], _responsiveBreakpoints.default.tablet(_templateObject2()));

var StyledIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "PhoneSupport__StyledIcon",
  componentId: "sc-6geeux-3"
})(["margin-right:10px;font-size:15px;", ""], _responsiveBreakpoints.default.tablet(_templateObject3()));
var StyledHeader = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "PhoneSupport__StyledHeader",
  componentId: "sc-6geeux-4"
})(["line-height:1.8;margin-bottom:0.75em;text-align:center;font-size:1.15em;.phone-support-header{display:block;}"]);

function PhoneSupport(_ref2) {
  var phoneSourceId = _ref2.phoneSourceId,
      border = _ref2.border,
      showCopy = _ref2.showCopy,
      screen = _ref2.screen;
  return _react.default.createElement(PhoneSupportWrapper, null, showCopy && _react.default.createElement(StyledHeader, {
    "data-selenium-id": "phone-support-header"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.crm.notSure",
    className: "phone-support-header"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.crm.notSureSubHeader",
    className: "phone-support-subheader"
  })), _react.default.createElement(PhoneSupportContainer, {
    className: "phone-support-container",
    border: border
  }, _react.default.createElement(PhoneNumberContainer, null, _react.default.createElement(StyledIcon, {
    name: "calling"
  }), _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      'pricing-pages-unified-ui/components/common/phone-numbers/AuthedPhoneNumber');
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      'pricing-pages-unified-ui/components/common/phone-numbers/PublicPhoneNumber');
    },
    authedComponentProps: {
      phoneSourceId: phoneSourceId,
      screen: screen
    },
    publicComponentProps: {
      phoneSourceId: phoneSourceId,
      screen: screen
    }
  }))));
}

PhoneSupport.propTypes = {
  phoneSourceId: _propTypes.default.string.isRequired,
  border: _propTypes.default.bool.isRequired,
  showCopy: _propTypes.default.bool.isRequired,
  screen: _propTypes.default.string.isRequired
};
PhoneSupport.defaultProps = {
  border: true,
  showCopy: true
};
var _default = PhoneSupport;
exports.default = _default;
module.exports = exports.default;